module.exports = __webpack_public_path__ + "img/titlebg.2bb1c04f.png";